module.exports = __webpack_public_path__ + "1c3235c3d73489bf3f74e44b3a0abfe7.svg";